import { authedAxios } from '../shared/axiosWrapper';
import { S2_TASK_TYPE_PATH } from '../constants';

export default {
  fetchAll() {
    return authedAxios.get(S2_TASK_TYPE_PATH);
  },
  fetchById(id) {
    return authedAxios.get(S2_TASK_TYPE_PATH + id);
  },

  updateTaskType(id, payload) {
    return authedAxios.put(S2_TASK_TYPE_PATH + id, payload);
  },

  createTaskType(payload) {
    return authedAxios.post(S2_TASK_TYPE_PATH, payload);
  }
};
